var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".email_svg__cls-2{fill:none;stroke:#1a2e3b;stroke-miterlimit:10;stroke-width:2px}.email_svg__cls-3{fill:#1a2e3b}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0a30 30 0 1030 30A30 30 0 0030 0",
    fill: "#e8eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    className: "email_svg__cls-2",
    d: "M24.85 32.78l-10 10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "email_svg__cls-3",
    d: "M17.14 25.77l-.08-.06 12.79-10.24 12.8 10.24-.08.06h3.2l.08-.06-16-12.8-16 12.8.09.06h3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "email_svg__cls-2",
    d: "M34.85 32.78l10 10"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    strokeMiterlimit: 10,
    stroke: "#1a2e3b",
    fill: "#e8eaeb",
    d: "M16.86 28.77l-.03-12.99h26.02v12.99"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.85,
    cy: 25.28,
    r: 5.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#1a2e3b",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "email_svg__cls-3",
    cx: 28.02,
    cy: 24.36,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "email_svg__cls-3",
    cx: 31.69,
    cy: 24.36,
    r: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.41 26.75a3.07 3.07 0 005 0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    stroke: "#1a2e3b",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "email_svg__cls-2",
    d: "M17.85 26.77h-3v16h30v-16h-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "email_svg__cls-2",
    d: "M44.85 26.77l-15 10-15-10"
  })))));
}
export default SvgEmail;